import { memo } from 'react';
import { Navigate, useLocation } from 'react-router';

function NoMatch() {
  const location = useLocation();
  return <Navigate to="/" replace state={{ from: location }} />;
}

export default memo(NoMatch);
